module.exports = __webpack_public_path__ + "static/kale-leaf-cut-5fe63d00f6e2d633f0f9427acb1cbea0.png";